import React, { useContext } from 'react';
import he from 'he';
import { TPAComponentsContext, Text, TextTypography } from 'wix-ui-tpa';
import { classes, st } from './EmptyState.st.css';
import { EmptyState as WSREmptyState, Box, Text as WSRText, } from '@wix/design-system';
function EmptyState(props) {
    const { mobile } = useContext(TPAComponentsContext);
    const { mainTitle, description, className, isDashboard = false } = props;
    if (isDashboard) {
        const wsrEmptyStateTitle = (React.createElement(WSRText, { size: "medium", weight: "bold" }, mainTitle));
        const wsrEmptyStateDescription = (React.createElement(WSRText, { size: "medium" },
            " ",
            description,
            " "));
        return (React.createElement(Box, { className: st(classes.emptyStateWsr) },
            React.createElement(WSREmptyState, { theme: "page-no-border", title: wsrEmptyStateTitle, align: "center", subtitle: wsrEmptyStateDescription, className: classes.wsrEmptyStateContainer })));
    }
    return (React.createElement("div", { className: st(classes.emptyState, { mobile }, className) },
        React.createElement(Text, { typography: TextTypography.smallTitle, className: st(classes.mainTitle) }, he.decode(mainTitle)),
        React.createElement(Text, { typography: TextTypography.runningText, className: st(classes.description) }, he.decode(description))));
}
export default EmptyState;
//# sourceMappingURL=EmptyState.js.map